// Restricted window, in Iran local time: from START (inclusive) to END
// (exclusive), wrapping past midnight (22:00 -> 07:00 next day).
export const NIGHT_RESTRICTION_START_HOUR = 22;
export const NIGHT_RESTRICTION_START_MINUTE = 0;
export const NIGHT_RESTRICTION_END_HOUR = 7;
export const NIGHT_RESTRICTION_END_MINUTE = 0;

// Uses the IANA zone directly so the check is correct regardless of the
// device's own timezone/locale settings.
export default function isIranNightTime(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Tehran',
    hour: 'numeric',
    minute: 'numeric',
    hourCycle: 'h23',
  }).formatToParts(date);

  const iranHour = Number(parts.find((p) => p.type === 'hour').value);
  const iranMinute = Number(parts.find((p) => p.type === 'minute').value);

  const nowMinutes = iranHour * 60 + iranMinute;
  const startMinutes =
    NIGHT_RESTRICTION_START_HOUR * 60 + NIGHT_RESTRICTION_START_MINUTE;
  const endMinutes =
    NIGHT_RESTRICTION_END_HOUR * 60 + NIGHT_RESTRICTION_END_MINUTE;

  // Window wraps midnight (e.g. 22:00 -> 07:00): "now" is inside it if
  // it's at/after the start OR still before the end.
  if (startMinutes > endMinutes) {
    return nowMinutes >= startMinutes || nowMinutes < endMinutes;
  }

  // Non-wrapping window, kept for completeness in case the bounds are
  // ever configured to sit within the same day.
  return nowMinutes >= startMinutes && nowMinutes < endMinutes;
}
